import React from 'react'
interface CloseImgProps {
  className?: string
}

const CloseImg = ({ className = 'dark' }: CloseImgProps) => {
  return (
    <svg
      className={className}
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9585 11.958L29.0418 29.0413M11.9585 29.0413L29.0418 11.958"
        stroke="currentColor"
        stroke-width="2.5625"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default CloseImg
